import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { SegmentedControl } from '@ui/components/SegmentedControl/SegmentedControl'
import { TextColorType } from '@ui/design-system/colors/colors'
import { MarkerIcon } from '@ui/icons/Marker.icon'

import { useGAEvents } from '@utils/callGAEvents'

import { Box } from '@shared/components/Box'

import styles from './TypeFilter.module.scss'

export enum PerformanceType {
  Commission = 'commission',
  Lots = 'lots',
  Clients = 'clients',
}

interface TypeFiltersProps {
  activeTab: PerformanceType
  onTabChanged: (tab: PerformanceType) => void
}

export const TypeFilter: FC<TypeFiltersProps> = (props) => {
  const { onTabChanged } = props

  const { callGAEvents } = useGAEvents()
  const { t } = useTranslation()

  const typeFilterTabs = [
    {
      id: PerformanceType.Commission,
      name: t('IB.Dashboard.Commission'),
    },
    {
      id: PerformanceType.Lots,
      name: t('IB.Dashboard.Lots'),
    },
    {
      id: PerformanceType.Clients,
      name: t('IB.Dashboard.Clients'),
    },
  ]

  const circleColor: Record<PerformanceType, { primary: TextColorType; secondary: TextColorType }> =
    {
      [PerformanceType.Commission]: {
        primary: 'text-warning-low-em',
        secondary: 'text-warning-high-em',
      },
      [PerformanceType.Lots]: {
        primary: 'text-success-low-em',
        secondary: 'text-success-high-em',
      },
      [PerformanceType.Clients]: { primary: 'text-info-low-em', secondary: 'text-info-high-em' },
    }

  const handleChipClick = (tab: string) => {
    onTabChanged(tab as PerformanceType)
    switch (tab as PerformanceType) {
      case PerformanceType.Commission:
        return callGAEvents().IBDashboard.QuickPerformance.commission()
      case PerformanceType.Clients:
        return callGAEvents().IBDashboard.QuickPerformance.clients()
      case PerformanceType.Lots:
        return callGAEvents().IBDashboard.QuickPerformance.lots()
    }
  }

  return (
    <Box flex gap='x4' className={styles.typeFilters}>
      <SegmentedControl
        size='md'
        tabs={typeFilterTabs.map((x) => ({
          id: x.id,
          iconLeft: MarkerIcon,
          name: x.name,
          iconColor: circleColor[x.id].primary,
          onClick: () => handleChipClick(x.id),
        }))}
      />
    </Box>
  )
}
